module.exports = __webpack_public_path__ + "static/media/lucca-profile.9559a042.jpeg";